import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  serviceBox: {
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: `${theme.spacingRules.cardPaddingDesktop}`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacingRules.cardPaddingMobile}`,
    },
  },
  styledHeadingText: {
    fontWeight: "400 !important",
    marginTop: "40px",
    fontSize: "30px",
    color: theme.agentTheme.background.secondary_text,
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
      marginTop: "24px",
    },
  },
  headingText: {
    fontWeight: "600 !important",
    fontSize: "28px",
    color: theme.agentTheme.background.primary_text,
  },
  serviceIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    backgroundColor: theme.agentTheme.primary.main,
    [theme.breakpoints.down("sm")]: {
      width: "120px",
      height: "120px",
    },
  },
  serviceNameText: {
    color: theme.agentTheme.background.primary_text,
    fontWeight: "500 !important",
    fontSize: "20px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "34px",
    },
  },
  mainContainer: {
    padding: theme.spacing(6, 2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4, 2),
      boxShadow: "none",
    },
  },
}));

export default useStyles;
